/**
 * @param {String} hex
 * @param {Boolean} isDarkShade
 * @returns {String}
*/
export function getTeamColor(hex, isDarkShade) {
  switch (hex) {
    // archived
    case '#AEAEAF':
      return hex;
    // red
    case '#F0AFA7':
    case '#83605B':
    case '#EC6959':
    case '#F96C5E':
    case '#AE3201':
    case '#EB596B':
    case '#C05E59':
    case '#F4735E':
    case '#FF8F84':
    case '#E1480B':
      return isDarkShade ? '#83605B' : '#F0AFA7';
    // bouquet
    case '#DABDCA':
    case '#77676E':
    case '#B57B94':
    case '#BA4E9E':
    case '#C7567A':
    case '#B92819':
      return isDarkShade ? '#77676E' : '#DABDCA';
    // plum
    case '#D7ABE1':
    case '#765D7B':
    case '#BA4D9F':
    case '#E2738C':
    case '#A15AA1':
    case '#8164A8':
    case '#8E5ACF':
    case '#A359A3':
    case '#AF56C2':
    case '#C589C5':
    case '#731F73':
      return isDarkShade ? '#765D7B' : '#D7ABE1';
    // blue
    case '#A9C7EF':
    case '#5C6D83':
    case '#5390E0':
    case '#04699A':
    case '#3F8AA6':
    case '#7875E1':
    case '#0991D3':
    case '#28A1DB':
      return isDarkShade ? '#5C6D83' : '#A9C7EF';
    // yellow
    case '#F6D28D':
    case '#87734D':
    case '#D28C07':
    case '#C6871F':
    case '#C4AE50':
    case '#F8AF26':
      return isDarkShade ? '#87734D' : '#F6D28D';
    // green
    case '#B8D2A9':
    case '#65735C':
    case '#7BAF5D':
    case '#27946B':
    case '#A0AF57':
    case '#067F67':
      return isDarkShade ? '#65735C' : '#B8D2A9';
    // mint
    case '#98D5CA':
    case '#53746E':
    case '#33AC96':
    case '#55C3AE':
    case '#00B57E':
    case '#5AAE76':
      return isDarkShade ? '#53746E' : '#98D5CA';
    // duck egg
    case '#90BDC1':
    case '#4F6769':
    case '#217C84':
    case '#3FAAB5':
      return isDarkShade ? '#4F6769' : '#90BDC1';
    // orange
    case '#F9BB85':
    case '#886649':
    case '#FE8216':
    case '#F05F20':
    case '#E99849':
    case '#EF824F':
    case '#E04838':
    case '#FF895A':
      return isDarkShade ? '#886649' : '#F9BB85';
    // cyan
    case '#81CDD4':
    case '#467074':
    case '#039BA9':
    case '#737885':
      return isDarkShade ? '#467074' : '#81CDD4';

    default:
      // return cyan for unmapped colors
      return isDarkShade ? '#467074' : '#81CDD4';
  }
}

export default {};
